import React from 'react';
import { Typography, Button, Box, Grid, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Save as SaveIcon } from '@material-ui/icons';
import PropTypes from 'prop-types';
import { TipoPremioPreco } from '@omega-energia/utilities';
import styles from '../PremioContainer.styles';
import PremioInput from '../PremioInput/PremioInput';

const useStyles = makeStyles(styles);

function PremioContainerCondicoesEspeciais(props) {
  const { values, handleSubmit, handleBlur, isSaveEnabled } = props;
  const classes = useStyles(props);

  return (
    <form onSubmit={e => handleSubmit(e, 'containerCondicoesEspeciais')}>
      <Paper className={classes.paper}>
        <Box display="flex" flexDirection="row" justifyContent="space-between" pb={4}>
          <Box>
            <Typography variant="h5">Condições Especiais</Typography>
          </Box>
          <Box>
            <Button
              size="large"
              variant="contained"
              color="primary"
              type="submit"
              align="right"
              disabled={!isSaveEnabled}
            >
              <SaveIcon className={classes.cardIcon} /> SALVAR
            </Button>
          </Box>
        </Box>

        <Grid container spacing={4}>
          <Grid item xs={6}>
            <PremioInput
              label="Off Mkt"
              name={`premioCredito[${TipoPremioPreco.OFF_MARKET_HOURS}]`}
              value={values?.premioCredito[TipoPremioPreco.OFF_MARKET_HOURS]}
              onBlur={e => handleBlur(e, 'containerCondicoesEspeciais')}
              maxLength={8}
            />
          </Grid>
          <Grid item xs={6}>
            <PremioInput
              label="Prazo Pgto"
              helperText="Incide por dia além do padrão: 6º d.u"
              name={`premioCredito[${TipoPremioPreco.PRAZO_PAGAMENTO}]`}
              value={values?.premioCredito[TipoPremioPreco.PRAZO_PAGAMENTO]}
              onBlur={e => handleBlur(e, 'containerCondicoesEspeciais')}
              maxLength={8}
            />
          </Grid>

          <Grid item xs={6} className={classes.marginTopWeekendMarket}>
            <PremioInput
              label="Weekend Mkt"
              name={`premioCredito[${TipoPremioPreco.OFF_MARKET_WEEKEND_HOURS}]`}
              value={values?.premioCredito[TipoPremioPreco.OFF_MARKET_WEEKEND_HOURS]}
              onBlur={e => handleBlur(e, 'containerCondicoesEspeciais')}
              maxLength={8}
            />
          </Grid>
        </Grid>
      </Paper>
    </form>
  );
}

PremioContainerCondicoesEspeciais.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  values: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  isSaveEnabled: PropTypes.bool.isRequired,
};

export default PremioContainerCondicoesEspeciais;
